
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';


if (window.location.hostname !== 'localhost') {
  enableProdMode();
}

export function startAngularApp() {

  return platformBrowserDynamic().bootstrapModule(AppModule);

}

(window as any).startAngularApp = startAngularApp;
